module.exports = __webpack_public_path__ + "static/media/shequ-content-4.aa72af26.png";